var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import useSetState from 'react-use-setstate';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/solid';
import { fromEvent } from 'rxjs';
import { Analytics } from 'data/Analytics';
import Button from '../components/Button';
import { PDPModal } from '../components/PDPModal';
import { SubscriptionBenefits, SubscriptionDetail, } from '../components/SubscriptionDetail';
import { BuyBox, QuantitySelect } from './components';
import { head } from 'lodash';
const SELECT_FREQUENCY = {
    id: 0,
    name: 'SELECT DELIVERY FREQUENCY',
    selling_plan_id: null,
};
let windowHelper = window;
let subscriptionIntervals = [SELECT_FREQUENCY];
const addSubscriptionInterval = (variantId, product) => {
    var _a;
    let defaultOption = '';
    const variantOption = (_a = vitalData.recommendedIntervals) === null || _a === void 0 ? void 0 : _a.variants[variantId];
    return (sellingPlan) => {
        if (variantOption &&
            variantOption == sellingPlan.options[0].value) {
            defaultOption = ' (Recommended)';
        }
        else {
            defaultOption = '';
        }
        let interval = `Ship every ${sellingPlan.options[0].value} ${defaultOption}`;
        subscriptionIntervals.push({
            id: sellingPlan.id,
            name: interval,
            selling_plan_id: sellingPlan.id,
        });
    };
};
const resetSubscriptionIntervals = () => {
    subscriptionIntervals = [SELECT_FREQUENCY];
};
function classNames(...classes) {
    return classes.join(' ');
}
/**
 * Return true if variant id is rationalized
 * @param variantId The variant ID
 */
function isRationalized(variantId) {
    return (window.vitalData.skusRationalized.find(p => p.variantId == variantId) != undefined);
}
/**
 * The PDP Buy Box Component Purchase Type
 * @type {string} onetime - One time purchase
 * @type {string} subscription - Subscription purchase
 */
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["ONETIME"] = "onetime";
    PurchaseType["SUBSCRIPTION"] = "subscription";
})(PurchaseType || (PurchaseType = {}));
// endregion
/**
 * PDP Buy Box Component
 * @returns PDP Component
 */
export function PDPBuyBox({ initialVariant, subscription, product, tags, shouldRedirectToLocator, }) {
    var _a, _b, _c, _d, _e, _f;
    let shippingIntervals, shippingIntervalUnit, initialSubscription;
    let isSubscribable = false;
    let sub = head(subscription);
    isSubscribable =
        (sub === null || sub === void 0 ? void 0 : sub.hasOwnProperty('selling_plans')) && sub.selling_plans.length > 0;
    const initialSelectedVariant = {
        variantTitle: initialVariant.name,
        variantSku: initialVariant.sku,
        variantStandardPrice: String(initialVariant.price / 100),
        variantCompareAtPrice: String((_a = initialVariant === null || initialVariant === void 0 ? void 0 : initialVariant.compare_at_price) !== null && _a !== void 0 ? _a : 0 / 100),
        variantSubscriptionPrice: String((_c = ((_b = initialVariant.selling_plan_allocations[0]) === null || _b === void 0 ? void 0 : _b.per_delivery_price) / 100) !== null && _c !== void 0 ? _c : 0),
        variantId: String(initialVariant.id),
        sellingPlans: sub === null || sub === void 0 ? void 0 : sub.selling_plans,
        sellingPlanAllocations: initialVariant.selling_plan_allocations,
        available: initialVariant.available,
    };
    if (isSubscribable) {
        const sellingPlanGroup = sub;
        const { options: sellingIntervals, selling_plans: sellingPlans } = sub;
        if (sellingPlans) {
            useMemo(() => sellingPlans.forEach(addSubscriptionInterval(initialVariant.id, product)), [shippingIntervalUnit]);
        }
    }
    let currentProductVariant = product.variants.find(product => product.id === Number(initialSelectedVariant.variantId));
    /* default to subscription if product requires selling plan */
    let purchaseType = product.requires_selling_plan
        ? PurchaseType.SUBSCRIPTION
        : PurchaseType.ONETIME;
    /**
     * Initial component state
     */
    let componentState = {
        purchaseType,
        selectedInterval: SELECT_FREQUENCY,
        isSubscription: product.requires_selling_plan,
        showCartModal: false,
        quantity: 1,
        selectedVariant: initialSelectedVariant,
        currentProductVariant,
    };
    const [state, setState] = useSetState(componentState);
    const [errors, setErrors] = useState({});
    // listen to clicks from the packing option
    useEffect(() => {
        const packagingOptionsClick = fromEvent($('.packaging-option'), 'click');
        const packagingOptionsClickSubscription = packagingOptionsClick.subscribe((e) => {
            var _a;
            const optionData = e.currentTarget.dataset;
            const selectedVariant = Object.assign(Object.assign({}, optionData), { sellingPlans: [], sellingPlanAllocations: [], available: /true/i.test(optionData.available) });
            const currentProductVariant = product.variants.find(product => product.id === Number(selectedVariant.variantId));
            const rationalized = isRationalized(currentProductVariant.id);
            $(`select[name="id"] option[value=${selectedVariant.variantId}]`)
                .prop('selected', 'selected')
                .change();
            $('.single-option-selector')
                .val(selectedVariant.variantTitle)
                .trigger('change');
            const option1 = $('.variant-title-option-1');
            if (currentProductVariant) {
                if (option1.length == 0) {
                    $('.variant-title').text(currentProductVariant.option1);
                }
                else {
                    option1.text(currentProductVariant.option1);
                    $('.variant-title-option-2').text(currentProductVariant.option2);
                }
            }
            const subscriptionPrice = (_a = head(currentProductVariant.selling_plan_allocations)) === null || _a === void 0 ? void 0 : _a.price;
            selectedVariant.variantSubscriptionPrice = formatCurrency(subscriptionPrice / 100);
            const updateContent = window.updateVariantContent;
            if (updateContent && typeof updateContent === 'function') {
                updateContent(selectedVariant.variantId);
            }
            //handle carousel change
            // @ts-ignore
            handleVariantChange({
                sku: selectedVariant.variantSku,
            });
            $('.packaging-option').removeClass('active');
            $(e.currentTarget).addClass('active');
            if (isSubscribable) {
                resetSubscriptionIntervals();
                const sellingPlans = sub.selling_plans;
                sellingPlans.forEach(addSubscriptionInterval(selectedVariant.variantId, product));
            }
            setState({
                selectedVariant,
                currentProductVariant,
                isSubscription: isSubscribable && !rationalized,
            });
        });
        //cleanup
        return () => {
            packagingOptionsClickSubscription.unsubscribe();
        };
    }, []);
    const trackUxaEvent = data => {
        var _a;
        try {
            const variantId = Number((_a = data.items[0]) === null || _a === void 0 ? void 0 : _a.id);
            const variants = window.variants || product.variants;
            const variant = variants === null || variants === void 0 ? void 0 : variants.find(i => i.id == variantId);
            if (variant) {
                windowHelper._uxa.push([
                    'ec:cart:add',
                    {
                        sku: variant.sku /* mandatory - Product code (SKU) (string) */,
                    },
                ]);
            }
        }
        catch (error) {
            const newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(error, {
                    componentName: 'PDP',
                    additionalInfo: 'AddtoCart'
                });
            }
        }
    };
    const addToCartRequest = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/cart/add.js', {
                method: 'POST',
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            trackUxaEvent(data);
            return response.json();
        }
        catch (error) {
            const newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(error, {
                    componentName: 'PDP',
                    additionalInfo: 'addToCartRequest'
                });
            }
            throw error;
        }
    });
    const removeItemFromCartRequest = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/cart/update.js', {
                method: 'POST',
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            return response.json();
        }
        catch (error) {
            // Handle fetch error
            const newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(error, {
                    componentName: 'PDP',
                    additionalInfo: 'removeItemFromCartRequest'
                });
            }
            throw error;
        }
    });
    const removeItemFromCart = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const cart = yield removeItemFromCartRequest(data);
            updateCartCount(cart.item_count);
            setState({ showCartModal: false });
        }
        catch (error) {
            // Handle errors from removeItemFromCartRequest
            const newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(error, {
                    componentName: 'PDP',
                    additionalInfo: 'removeItemFromCart'
                });
            } // Display an error message or perform error handling as needed
        }
    });
    const getCartRequest = () => __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch('/cart.js', {
            method: 'GET',
            mode: 'same-origin',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.json();
    });
    function isSubscription() {
        return state.purchaseType === 'subscription';
    }
    function isOneTime() {
        return state.purchaseType === 'onetime';
    }
    /**
     * Get data for posting to cart.js
     * @returns  The Items to add to the cart
     * @see CartItems
     */
    const getItems = () => {
        let item = {
            quantity: state.quantity,
            id: state.selectedVariant.variantId,
            properties: {},
        };
        if (state.purchaseType === 'subscription' &&
            state.selectedInterval &&
            state.selectedInterval.selling_plan_id) {
            item.selling_plan = state.selectedInterval.selling_plan_id;
        }
        return { items: [item] };
    };
    /**
     * Update Cart Count Element
     * @param el The html element
     * @param count The cart item count
     */
    const updateCartElement = (el, count) => {
        if (el)
            el.innerText = String(count);
    };
    const updateCartCount = (count) => {
        const countElements = [].slice.call(document.getElementsByClassName('cartCount'));
        countElements.forEach((element) => updateCartElement(element, count));
    };
    /**
     * Add to cart and show modal
     * @param evt The add to cart click event
     * @returns
     */
    const addToCart = (evt) => __awaiter(this, void 0, void 0, function* () {
        evt.preventDefault();
        if (state.purchaseType === 'subscription' &&
            (state.selectedInterval.id === null || state.selectedInterval.id === 0)) {
            setErrors({
                noSelectedInterval: true,
            });
            return false;
        }
        try {
            const data = getItems();
            yield window.cartManager.addItem(data);
            trackUxaEvent(data);
            try {
                const updatedCart = yield getCartRequest();
                updateCartCount(updatedCart.item_count);
                Analytics.trackAddToCart(Object.assign(Object.assign(Object.assign({}, state.selectedVariant), state.currentProductVariant), { quantity: state.quantity, isSubscription: state.isSubscription }));
            }
            catch (error) {
                console.error(error);
            }
        }
        catch (e) {
            console.error(e);
            alert('Error adding to cart.');
        }
        return false;
    });
    /**
     * Sets the state to the isSubscription value
     * @param isSubscription True when purchase is subscription
     */
    const setSubscription = (isSubscription) => {
        setState({ isSubscription });
    };
    const sanitizeTitle = (title) => {
        const pattern = /[(]UPC[\w[:][ ][0-9]+[)]/g;
        return title.replace(pattern, '');
    };
    const onSelectOnetime = evt => {
        const purchaseType = PurchaseType.ONETIME;
        setState({ purchaseType });
        setErrors({});
        evt.currentTarget.value == 'on'
            ? setSubscription(false)
            : setSubscription(true);
    };
    const onSelectSubscription = evt => {
        const purchaseType = PurchaseType.SUBSCRIPTION;
        setState({ purchaseType });
        setErrors({});
        evt.currentTarget.value == 'on'
            ? setSubscription(true)
            : setSubscription(false);
    };
    const compareMoneyValues = (compareAtPrice, price) => {
        // Convert compareAtPrice to actual price
        const compareAtPriceValue = compareAtPrice / 100;
        // Compare the prices
        return Number(compareAtPriceValue).toFixed(2) > Number(price).toFixed(2);
    };
    function isCompareAtGreater() {
        return compareMoneyValues(state.selectedVariant.variantCompareAtPrice, state.selectedVariant.variantStandardPrice);
    }
    function isOutOfStock() {
        if (summerShip)
            return true;
        const selectedVariantId = Number(state.selectedVariant.variantId);
        if (!selectedVariantId)
            return false;
        const variant = product.variants.find(v => {
            return v.id === selectedVariantId;
        });
        if (!variant) {
            return false;
        }
        return variant.inventory_quantity === 0;
    }
    let summerShip = (tags && tags.find(t => t == 'summer-ship')) ? true : false;
    return (React.createElement(React.Fragment, null,
        state.selectedVariant.available === true ? (React.createElement(QuantitySelect, { onChange: count => setState({ quantity: count }) })) : (React.createElement(React.Fragment, null)),
        React.createElement("div", { className: "" },
            React.createElement("div", { role: "group", "aria-labelledby": "label-notifications" },
                React.createElement("div", { className: "sm:grid sm:grid-cols-1 sm:gap-4 sm:items-baseline" },
                    React.createElement("div", { className: "sm:col-span-2" },
                        React.createElement("div", { className: "max-w-lg" }, state.selectedVariant.available === true ? (React.createElement("div", { className: "mt-4 space-y-4" },
                            React.createElement("div", { className: "flex items-center" },
                                React.createElement("label", { htmlFor: "onetime", className: "grid items-center gap-3 grid-cols-[1em_auto] text-sm font-medium text-gray-700" },
                                    React.createElement("input", { id: "onetime", name: "purchase-mode", type: "radio", checked: isOneTime(), className: "appearance-none !bg-white m-0 font-[inherit] w-3 h-3 text-current ring-2 ring-[#1675ff] ring-offset-2 rounded-full checked:!bg-[#1675ff]", onChange: onSelectOnetime }),
                                    React.createElement("span", null,
                                        "One-Time Purchase for",
                                        ' ',
                                        React.createElement("span", { className: `text-lg font-bold text-gray-700 sm:mt-px sm:pt-2 ${isCompareAtGreater() ? 'text-red' : ''}` }, formatCurrency(state.selectedVariant.variantStandardPrice)),
                                        "\u00A0",
                                        isCompareAtGreater() ? (React.createElement("span", { className: "text-lg line-through opacity-70 font-bold text-gray-700 sm:mt-px sm:pt-2 text-darkGray" }, formatCurrency(state.selectedVariant.variantCompareAtPrice, true))) : null))),
                            isSubscribable &&
                                window.vitalData.skusRationalized.find(p => p.variantId == state.selectedVariant.variantId) == undefined ? (React.createElement("div", { className: "flex items-center" },
                                React.createElement("label", { htmlFor: "subscribe", className: "grid items-center gap-3 grid-cols-[1em_auto] text-sm font-medium text-gray-700" },
                                    React.createElement("input", { id: "subscribe", name: "purchase-mode", type: "radio", checked: isSubscription(), className: "appearance-none !bg-white m-0 font-[inherit] w-3 h-3 text-current ring-2 ring-[#1675ff] ring-offset-2 rounded-full checked:!bg-[#1675ff]", onChange: onSelectSubscription }),
                                    React.createElement("span", null,
                                        "Subscribe & Save for",
                                        ' ',
                                        React.createElement("span", { className: "text-lg font-bold text-gray-700 sm:mt-px sm:pt-2" },
                                            formatCurrency(state.selectedVariant.variantSubscriptionPrice),
                                            "*"))))) : null)) : null))))),
        isSubscription() && state.selectedVariant.available === true ? (React.createElement("div", { className: "py-2" },
            React.createElement(Listbox, { value: state.selectedInterval, onChange: i => {
                    setErrors({});
                    setState({ selectedInterval: i });
                } }, ({ open }) => (React.createElement(React.Fragment, null,
                React.createElement(Listbox.Label, { className: "block text-sm font-medium text-gray-700" }),
                React.createElement("div", { className: "mt-1 relative" },
                    React.createElement(Listbox.Button, { className: "bg-white justify-start relative w-full border border-gray-300 rounded shadow-sm pl-2 pr-2 py-3 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-navy-blue-500 focus:border-indigo-500 sm:text-sm" },
                        React.createElement("span", { className: "block truncate font-sans" }, state.selectedInterval.name),
                        React.createElement("span", { className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" },
                            React.createElement("svg", { className: "cursor-pointer ml-2", width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                React.createElement("path", { d: "M2.66699 6.5L8.00033 11.8333L13.3337 6.5", stroke: "#393D40", strokeLinecap: "round", strokeWidth: 2, strokeLinejoin: "round" })))),
                    React.createElement(Transition, { show: open, as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0" },
                        React.createElement(Listbox.Options, { className: "list-none pl-0 h-60 overflow-auto absolute z-[1000] bg-white border border-light-gray rounded shadow-lg", style: { width: "-webkit-fill-available" } }, subscriptionIntervals.map((interval, index, arr) => (React.createElement(Listbox.Option, { key: index, value: interval }, ({ selected, active }) => (React.createElement("div", { className: `flex ${active ? 'bg-navy-blue-500 text-white' : ''}` },
                            selected ? (React.createElement("span", { className: `'absolute inset-y-0 right-0 flex items-center pl-4 ${active ? 'text-white' : 'text-indigo-600'}` },
                                React.createElement(CheckIcon, { className: "h-5 w-5" }))) : React.createElement("div", { className: "w-[36px]" }),
                            React.createElement("span", { className: `cursor-pointer flex-1 px-4 py-2 ${selected ? 'font-semibold' : ''}` }, interval.name)))))))))))))) : isSubscribable &&
            window.vitalData.skusRationalized.find(p => p.variantId == state.selectedVariant.variantId) == undefined &&
            state.selectedVariant.available === true ? (React.createElement(SubscriptionBenefits, null)) : (React.createElement("div", { className: "h-32 md:h-64" })),
        React.createElement(BuyBox, { purchaseType: state.purchaseType, selectedVariant: state.selectedVariant, isSubscription: state.isSubscription, selectedInterval: state.selectedInterval, tags: tags, addToCart: addToCart, hideSoldOutButton: shouldRedirectToLocator }),
        errors.noSelectedInterval && (React.createElement("div", { className: "text-red" }, "You must provide a Delivery Frequency.")),
        React.createElement(SubscriptionDetail, { redirectToLocator: isOutOfStock(), isSubscription: isSubscription(), isSubscribable: isSubscribable, discount: (_f = (_e = (_d = subscription[0]) === null || _d === void 0 ? void 0 : _d.selling_plans[0]) === null || _e === void 0 ? void 0 : _e.price_adjustments[0]) === null || _f === void 0 ? void 0 : _f.value }),
        state.showCartModal ? (React.createElement(PDPModal, { visible: state.showCartModal, setVisible: s => setState({ showCartModal: s }), title: `Item${state.quantity > 1 ? 's' : ''} Added to Cart` },
            React.createElement("div", { className: "flex flex-row" },
                React.createElement("div", { className: "flex-none w-24 " },
                    React.createElement("img", { className: "object-contain w-24", src: state.currentProductVariant.featured_image.src })),
                React.createElement("div", { className: "flex-1 product-details" },
                    React.createElement("div", { className: "px-4" },
                        React.createElement("div", { className: "mb-2" },
                            React.createElement("p", { className: "", style: {
                                    fontWeight: 400,
                                    fontSize: '28px',
                                    lineHeight: '28px',
                                    fontFamily: "Kapra ,'KapraNeue'",
                                } },
                                state.quantity,
                                " x",
                                ' ',
                                sanitizeTitle(state.selectedVariant.variantTitle))),
                        React.createElement("div", null,
                            React.createElement("pre", { className: "hidden" }, JSON.stringify(state.selectedInterval)),
                            state.isSubscription
                                ? `${state.selectedInterval.name} for ${formatCurrency(state.selectedVariant.variantSubscriptionPrice)}`
                                : `One-Time Purchase for ${formatCurrency(state.selectedVariant.variantStandardPrice)}`),
                        React.createElement("div", null,
                            React.createElement("span", { onClick: () => removeItemFromCart({
                                    updates: {
                                        [state.selectedVariant.variantId]: 0,
                                    },
                                }), className: "cursor-pointer uppercase text-navy-blue-500 text-sm font-bold underline" }, "Remove Item"))))),
            React.createElement("div", { className: "mt-5 sm:mt-6" },
                React.createElement(Button, { onClick: () => setState({ showCartModal: false }), disableLoader: true }, "Continue Shopping")),
            React.createElement("div", { className: "mt-5 sm:mt-6" },
                React.createElement(Button, { outline: true, onClick: () => {
                        setState({ showCartModal: false });
                        window.location.href = '/cart';
                    }, disableLoader: true }, "View Cart & Checkout")))) : null));
}
/**
 * Standard currency format in en-us USD
 * @param amount The amount
 * @param money Whether to divide by 100 or not
 * @returns String currency representation
 */
function formatCurrency(amount, money = false) {
    let sanitizedAmount = String(amount).replace('$', '');
    if (isNaN(Number(sanitizedAmount))) {
        console.error('Invalid numeric value for amount: ', sanitizedAmount);
        return '$0.00';
    }
    if (money) {
        sanitizedAmount = (Number(sanitizedAmount) / 100).toString();
    }
    return new Intl.NumberFormat('en-us', {
        style: 'currency',
        currency: 'USD',
    }).format(Number(sanitizedAmount));
}
